<!--
  This file is part of vospace-ui
  Copyright (C) 2021 Istituto Nazionale di Astrofisica
  SPDX-License-Identifier: GPL-3.0-or-later
-->
<template>
<div id="app">
  <TopMenu />
  <div class="container">
    <router-view></router-view>
  </div>
  <div id="footer-fix"></div>
  <footer class="text-center" id="site-footer">
    —&nbsp;Powered by <img alt="IA2 logo" src="./assets/ia2-logo-footer.png">
    <strong class="text-primary"><a href="http://www.ia2.inaf.it/" target="_blank">IA2</a></strong>&nbsp;—
  </footer>
  <div id="loading" v-if="loading" class="loading">
    <div class="spinner-wrapper">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Loading"></b-spinner>
    </div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import TopMenu from './components/TopMenu.vue'
import client from 'api-client'
import nodesReloader from './nodesReloader.js'

export default {
  name: 'App',
  computed: mapState({
    loading: state => state.loading
  }),
  components: {
    TopMenu
  },
  mounted() {
    this.$store.dispatch('loadJobs');
    this.$store.dispatch('loadUserInfo');
    setInterval(client.keepalive, 60000);
    setInterval(nodesReloader.checkNodes, 1000);
    let self = this;
    setInterval(function() {
      if (self.$router.currentRoute.path !== '/jobs') {
        self.$store.dispatch('checkJobs');
      }
    }, 1000);

    // Add event listener for dots menus
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('dots-menu')) {
        for (let menu of document.querySelectorAll('.dots-menu')) {
          menu.classList.remove('active');
        }
        event.target.classList.toggle('active')
      } else {
        if (event.target.closest('.dots-menu') === null) {
          for (let menu of document.querySelectorAll('.dots-menu')) {
            menu.classList.remove('active');
          }
        }
      }
    });
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#footer-fix {
  display: block;
  width: 100%;
  height: 100px;
}

#site-footer {
  color: #666;
  border-top: 1px #e7e7e7 solid;
  background-color: #f8f8f8;
  padding: 5px 0;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
}

.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 100000;
}

.spinner-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.node-busy {
  position: relative;
}

.node-busy .spinner-border {
  position: absolute;
  left: -5px;
  font-size: 7px;
  height: 26px;
  width: 26px;
  top: -7px;
  color: #3293f2;
}

.node-busy+.icon {
  margin-right: 3px;
}

.dots-menu {
  position: relative;
}

.dots-menu-content {
  display: none;
  position: absolute;
  /*background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;*/
}

.dots-menu.active .dots-menu-content {
  display: block;
}
</style>
